/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements/New/LastExecution/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let reportLastExecutionCreatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'report',
path: 'last_execution.created_at',
format: fromFormat.dateISOToDateAndTime,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let reportLastExecutionIdValueData = fromData.useDataValue({ viewPath,
context: 'report',
path: 'last_execution.id',
})
let reportLastExecutionMessageValueData = fromData.useDataValue({ viewPath,
context: 'report',
path: 'last_execution.message',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="bold"
 text="Last execution:"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 size="small"
 data="report.last_execution.created_at"
 format="/Data/format.js dateISOToDateAndTime"
 text={reportLastExecutionCreatedAtValueData}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 data="report.last_execution.id"
 text={reportLastExecutionIdValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 data="report.last_execution.message"
 text={reportLastExecutionMessageValueData}
/>
</div>
{children}
</React.Fragment>)
}